module.exports = __webpack_public_path__ + "images/dishonored-2_rgba(0,0,0,0.7).c46fddd2b63aebe06a5c9041f8145c1e.jpg";